module.exports = __webpack_public_path__ + "img/coach-champ-logo.6aba48d5.svg";